import { ITienDoNhapDiemLopTinChiActionTypes } from "../../action-types/tong-hop/ITienDoNhapDiemLopTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITienDoNhapDiemLopTinChiReducer } from "../../reducer-model/tong-hop/ITienDoNhapDiemLopTinChiReducer";

const iniState: ITienDoNhapDiemLopTinChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tienDoNhapDiems: [],
};

export const tienDoNhapDiemLopTinChiReducer = (state = iniState, action: ITienDoNhapDiemLopTinChiActionTypes): ITienDoNhapDiemLopTinChiReducer => {
    switch (action.type) {
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THANH_PHAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THANH_PHAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tienDoNhapDiems: action.payload,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THANH_PHAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THI_LOAD_START": 
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tienDoNhapDiems: action.payload,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}